module.exports = __webpack_public_path__ + "assets/img/detail11.c21aff7f.png";